import { Award, BookOpen, Cloud, Database } from "lucide-react";

const highlights = [
  { icon: Award, label: "3+ Decades Experience" },
  { icon: Cloud, label: "OCI, Azure, AWS Expert" },
  { icon: Database, label: "Oracle Database Specialist" },
  { icon: BookOpen, label: "Training Professional" },
];

const expertise = [
  "Focused on OCI, Azure, AWS Database Architecture, Multi-Cloud Architecture and Solution Architecture within industries requiring extensive experience in strategic AWS Cloud Architecture, IT Infrastructure, and Cloud and DevOps Integration.",
  "Expertise in designing, implementing, and managing cloud solutions, with a strong background in on-premises enterprise environment.",
  "Expert in Database designing, implementing, and optimizing cloud solutions, resulting in improved system performance, cost savings, and seamless integration with existing IT infrastructure.",
];

export default function InstructorSection() {
  return (
    <section id="instructor" data-testid="instructor-section" className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="mb-12">
        <p className="font-mono text-xs text-[#22D3EE] uppercase tracking-widest mb-2">// your guide</p>
        <h2 className="font-['Space_Grotesk'] text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-[#F4F4F5]">
          Meet Your Instructor
        </h2>
      </div>

      <div className="p-8 bg-[#111118] border border-[#27272A] rounded-md">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Name & title */}
          <div className="lg:w-1/3">
            <div className="w-20 h-20 rounded-md bg-[#E32636]/10 border border-[#E32636]/20 flex items-center justify-center mb-4">
              <span className="font-['Space_Grotesk'] text-2xl font-bold text-[#E32636]">KK</span>
            </div>
            <h3 className="font-['Space_Grotesk'] text-xl sm:text-2xl font-semibold text-[#F4F4F5] mb-1">
              Kanhiyalal Kushwaha
            </h3>
            <p className="text-[#E32636] font-medium text-sm mb-6">
              Senior-level Cloud Solutions Architect
            </p>
            <p className="text-xs text-[#71717A] mb-6">Cloud Database Architect</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-2">
              {highlights.map((item) => {
                const Icon = item.icon;
                return (
                  <div
                    key={item.label}
                    className="flex items-center gap-2 p-3 bg-[#16161F] border border-[#27272A] rounded-md"
                  >
                    <Icon size={14} className="text-[#22D3EE] flex-shrink-0" />
                    <span className="text-xs font-medium text-[#A1A1AA]">{item.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Bio */}
          <div className="lg:w-2/3 flex flex-col justify-center">
            <p className="text-sm text-[#A1A1AA] leading-relaxed mb-6">
              A Senior-level Cloud Solutions Architect with <span className="text-[#F4F4F5] font-semibold">over 3 decades</span> of expertise in Training, Application, Oracle Databases, and Infrastructure.
            </p>
            <div className="space-y-4">
              {expertise.map((text, i) => (
                <div key={i} className="flex gap-3">
                  <span className="flex-shrink-0 w-1 bg-[#27272A] rounded-full" />
                  <p className="text-sm text-[#71717A] leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
